export default function Loader() {
  return <div className="mx-auto h-10 w-10 animate-spin rounded-full border-4 border-emerald-100 border-t-primary" aria-label="Loading" />;
}
